import {
	OnInit,
	OnDestroy,
	Directive,
	ElementRef,
	Input,
	OnChanges,
	SimpleChanges,
} from '@angular/core';

declare var am4core:any;
declare var am4charts:any;
declare var am4themes_animated:any;

import { FnChartService } from './fnchart.service';
import { FnScriptLoaderService } from '../../../services/fn-script-loader.service';
import {
	ChartSettingConfig,
	BNEStackedChartConf,
} from '../../../constant/fn-chart-type.enum';

/**
 * This Directive is used to create charts.
 */
@Directive({
	selector: '[fnChart]',
})
export class FnChartDirective implements OnInit, OnDestroy, OnChanges {
	/**
	 * Input member variable
	 * used to provide the type chart to create like LineChart ,graph etc.;
	 */
	@Input() fnChart: string | number;
	/**
	 *  Input member variable
	 *  used to provide data for Chart.
	 */
	@Input() data: Array<any> = [];
	/**
	 * Input member variable
	 * used to provide the extended chart settings
	 */
	@Input() config: ChartSettingConfig;
	/**PieChartSettings
	 * private member variable of any Type.
	 * default Value is null
	 * used to store reference of ChartObject.
	 */
	private chart: any = null;
	constructor(
		private elmRef: ElementRef,
		private fnChartService: FnChartService,
		private fnScriptLoaderService: FnScriptLoaderService
	) {}

	/**
	 *  Implements ngOnInit event handler
	 */
	ngOnInit() {
		this.loadChartScript();
	}
	/**
	 * Implements ngOnChanges event handler
	 * to update Chart when data Changes
	 * @param changes SimpleChanges Ref
	 */
	ngOnChanges(changes: SimpleChanges) {
		const data = changes['data'];
		if (data.currentValue !== data.previousValue) {
			this.updateChart();
		}
	}

	/**
	 * Implements ngOnChanges event handler to call destroyChart() method to distroy Chart Object
	 */
	ngOnDestroy() {
		this.destroyChart();
	}

	/**
	 * Create Chart
	 */
	private createChart() {
		this.destroyChart();
		const chart = am4core.create(
			this.elmRef.nativeElement,
			am4charts[this.chartConf(this.fnChart)]
		);
		chart.logo.disabled = true;
		this.fnChartService.setConfig(chart, this.fnChart, this.config);
		this.chart = chart;
		this.chart.data = this.data;
	}

	/**
	 * Update Chart Data
	 */
	private updateChart() {
		if (this.chart) {
			this.chart.data = this.data;
			this.chart.invalidateData();
		} else {
			this.loadChartScript();
		}
	}

	/**
	 * Destroy Chart
	 */
	private destroyChart() {
		if (this.chart) {
			this.chart.dispose();
			this.chart = null;
		}
	}

	private chartConf(chartType: string | number) {
		switch (chartType) {
			case 'DonutChart':
				return 'PieChart';
			case 'StackColumnChart':
				return 'XYChart';
			case 'ClusterColumnChart':
				return 'XYChart';
			case 'LineChart':
				return 'XYChart';
			default:
				return chartType;
		}
	}

	/**
	 * Load AmChart JS differentailly
	 */
	private loadChartScript() {
		this.fnScriptLoaderService
			.load('amchart-core')
			.then((data) => {
				this.fnScriptLoaderService
					.load('amchart-charts')
					.then((_data) => {
						this.fnScriptLoaderService
							.load('amchart-animated')
							.then((__data) => {
								am4core.ready(() => {
									am4core.useTheme(am4themes_animated);
									this.createChart();
								});
								// Script Loaded Successfully
							})
							.catch((error) => console.log(error));
					})
					.catch((error) => console.log(error));
			})
			.catch((error) => console.log(error));
	}
}
